import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  token: any;
  plan: any;
  cachedPlans: any;
  cachedUserAmount: any;
  quantity = 1;

  source = 'checkout';

  upgrade = false;

  endpoint = environment.paymentEndpoint;

  purchasev2Endpoint = environment.purchaseEndpoint;


  constructor(private http: HttpClient) { }


  getCachedPlans() {
    return this.cachedPlans;
  }

  getCachedAmount() {
    return this.cachedUserAmount;
  }

  setPlan(plan: string, price: string, subs?: string) {
    localStorage.setItem('plan_pay', plan);
    localStorage.setItem('price_pay', price);

    this.plan = plan;

    // this.gtagService.sendGtagRequest('add_to_cart', plan);
  }

  getPlan() {
    return this.plan;
  }

  sendPay(token: any, liccode: string, email: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    console.log(email);
    if (email == null || email === '') {
      alert('Please insert your email or plan.');
      return new Observable();
    }

    const date = Date.now() / 1000;
    const eToken = email.charCodeAt(0) + email.charCodeAt(1);
    console.log('eToken: ', eToken);

    console.log(liccode);

    if (liccode == null) {
      alert('Please insert your email or plan.');
      return new Observable();
    }

    const postBody = {
      email,
      quantity: this.quantity,
      token: JSON.stringify(token),
      liccode: liccode,
      t: date,
      e: eToken
    };


    return this.http.post(this.endpoint + '/subscribe', postBody, httpOptions);
  }

  delete() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const email = localStorage.getItem('email_pay');
    const plan = localStorage.getItem('plan_pay');
    let provider = 'pw';
    if (plan === '6002' || plan === '6003' || plan === '6009') {
      provider = 'comm';
    }

    const postBody = {
      'email': email,
      'provider': provider,
    };

    return this.http.post(this.endpoint + '/delete', postBody, httpOptions);
  }

  getLocalStorage(type: string) {
    return localStorage.getItem(type + '_pay');

  }

  createSession(email, priceId) {
    const postBody = {
      email,
      priceId,
      source: this.source
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(this.purchasev2Endpoint + '/create-session', postBody, httpOptions);
  }

  createTrial(email) {
    const postBody = {
      email,
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(this.endpoint + '/plustrial', postBody, httpOptions);
  }

}
